// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { NotFoundGetString } from './types.generated'

const notFoundLocales = ['en-US'] as const

export const getString: NotFoundGetString = i18nBundle('notFound', notFoundLocales).getString

